import siteUrl from '@/utils/url/site'
export default async (args = {}) => {
  const r = await axios.get('site/equipe'), carousel = [], names = []
  r.forEach(i => {
    carousel.push({
      avatar: 'src/fotos/equipe/' + i.image,
      subtitle: i.funcao,
      actions: {
        color: "error darken-2",
        icon: "account-badge-horizontal-outline",
        text: i.name,
        action: siteUrl('equipe/' + i.lnk)
      }
    });
    names.push('<strong>' + i.name + '</strong>')
  });
  return {
    msg: `<div class="mb-2">Nossa equipe é formada por vários profissionais especializados.</div>`,
    carousel
  }
}